/**
 * delete-schema-requests.ts
 * Copyright (c) 2016-2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DeleteDataExportSchemaRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_DELETE_DATA_EXPORT_SCHEMA;
  public static tag : MessageTag = MessageTag.REQ_DELETE_DATA_EXPORT_SCHEMA;

  constructor (public schemaId : number)
  {
    super();
  }
}

export class DeleteAggregationSchemaRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_DELETE_AGGREGATION_SCHEMA;
  public static tag : MessageTag = MessageTag.REQ_DELETE_AGGREGATION_SCHEMA;

  constructor (public schemaId : number)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/schemas/delete-schema-requests.ts